import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const postUsuario = createAsyncThunk(
  "user/postUsuarios",
  async (payload) => {
    console.log(payload.name);
    const response = await axios.post(
      "https://yourbillsbackend-production.up.railway.app/api/Usuarios",
      payload
    );

    return response;
  }
);
export const login = createAsyncThunk("user/logiun", async (payload) => {
  console.log(payload);
  const response = await axios
    .post(
      "https://yourbillsbackend-production.up.railway.app/api/Usuarios/login",
      payload
    )
    .then((response) => response.data)
    .catch(({ response }) => response.data);
  console.log(response);
  return response;
});

const initialState = {
  userCredentials: JSON.parse(localStorage.getItem("userCredentials")) || {},
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    logOut: (state) => {
      localStorage.removeItem("userCredentials");
      state.userCredentials = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        console.log("Logueando");
      })
      .addCase(login.fulfilled, (state, action) => {
        if ("token" in action.payload) {
          localStorage.setItem(
            "userCredentials",
            JSON.stringify(action.payload)
          );
          state.userCredentials = action.payload;
        }
      })
      .addCase(postUsuario.pending, () => {
        console.log("creando");
      });
  },
});
export const { logOut } = userSlice.actions;

export default userSlice.reducer;
